import {
	MORTALITY_RESIDUE_IDS,
	MORTALITY_RESIDUES,
} from './residuosObservacionesAuto';
import { PRIMARY_PLANT_TYPE_ID } from '../constants/guideConstants';

const hasVal = v => v != null && v !== '';

/**
 * Fragmentos de DscItem para mortalidad, en orden de relevancia por tipo de residuo.
 * @param {object} d - detail con residue_id y campos de mortalidad
 * @param {object} [options] - opciones adicionales
 * @param {string} [options.establishmentTypeId] - tipo de establecimiento de origen
 * @returns {string[]} partes listas para unir con ", "
 */
export function buildMortalityDetailDescriptionParts(d, options = {}) {
	const rid = d.residue_id;
	const parts = [];
	const isPrimaryPlant = options.establishmentTypeId === PRIMARY_PLANT_TYPE_ID;

	if (rid === MORTALITY_RESIDUE_IDS.ENSILADA) {
		if (d.especie) parts.push(`Especie: ${d.especie}`);
		if (hasVal(d.fish_count)) parts.push(`Nro. de peces: ${d.fish_count}`);
		if (hasVal(d.number_of_bins)) parts.push(`Bins: ${d.number_of_bins}`);
		if (hasVal(d.cubic_meters)) parts.push(`m³: ${d.cubic_meters}`);
		if (hasVal(d.ph_ensilage)) parts.push(`pH: ${d.ph_ensilage}`);
		// TODO: Ácido sulfhídrico deshabilitado temporalmente. Conservado en backend para uso futuro.
		// if (hasVal(d.hydrogen_sulfide))
		// 	parts.push(`Ácido: ${d.hydrogen_sulfide}`);
		if (d.has_flow_meter != null) {
			parts.push(`Flujómetro: ${d.has_flow_meter ? 'Sí' : 'No'}`);
		}
		if (d.period) parts.push(`Periodo: ${d.period}`);
		return parts;
	}

	if (rid === MORTALITY_RESIDUE_IDS.PECES_ENTEROS) {
		if (d.especie) parts.push(`Especie: ${d.especie}`);
		// Label estandarizado: siempre "Nro. de peces" (igual que en glosas y UI)
		if (hasVal(d.fish_count))
			parts.push(`Nro. de peces: ${d.fish_count}`);
		if (d.cultivation_center_origin) {
			parts.push(`Centro cultivo: ${d.cultivation_center_origin}`);
		}
		if (d.siep_code_cultivation_center) {
			parts.push(`SIEP centro: ${d.siep_code_cultivation_center}`);
		}
		if (d.cage_origin) parts.push(`Jaula: ${d.cage_origin}`);
		if (hasVal(d.number_of_bins)) parts.push(`Bins: ${d.number_of_bins}`);
		if (d.bin_seal_folios) parts.push(`Sellos bins: ${d.bin_seal_folios}`);
		return parts;
	}

	if (rid === MORTALITY_RESIDUE_IDS.VISCERAS) {
		if (d.especie) parts.push(`Especie: ${d.especie}`);
		if (hasVal(d.number_of_bins)) parts.push(`Bins: ${d.number_of_bins}`);
		if (d.cultivation_center_origin) {
			parts.push(`Centro cultivo: ${d.cultivation_center_origin}`);
		}
		if (d.siep_code_cultivation_center) {
			parts.push(`SIEP centro: ${d.siep_code_cultivation_center}`);
		}
		if (d.cage_origin) parts.push(`Jaula: ${d.cage_origin}`);
		if (d.market_restrictions) {
			parts.push(`Restricciones: ${d.market_restrictions}`);
		}
		return parts;
	}

	// Mortalidad desconocida en catálogo pero marcada en lista: orden genérico seguro
	if (MORTALITY_RESIDUES.includes(rid)) {
		if (d.especie) parts.push(`Especie: ${d.especie}`);
		if (hasVal(d.fish_count)) parts.push(`Nro. de peces: ${d.fish_count}`);
		if (hasVal(d.number_of_bins)) parts.push(`Bins: ${d.number_of_bins}`);
		if (hasVal(d.cubic_meters)) parts.push(`m³: ${d.cubic_meters}`);
		if (hasVal(d.ph_ensilage)) parts.push(`pH: ${d.ph_ensilage}`);
		// TODO: Ácido sulfhídrico deshabilitado temporalmente. Conservado en backend para uso futuro.
		// if (hasVal(d.hydrogen_sulfide))
		// 	parts.push(`Ácido: ${d.hydrogen_sulfide}`);
		if (d.has_flow_meter != null) {
			parts.push(`Flujómetro: ${d.has_flow_meter ? 'Sí' : 'No'}`);
		}
		if (d.period) parts.push(`Periodo: ${d.period}`);
		if (d.cultivation_center_origin) {
			parts.push(`Centro cultivo: ${d.cultivation_center_origin}`);
		}
		if (d.siep_code_cultivation_center) {
			parts.push(`SIEP centro: ${d.siep_code_cultivation_center}`);
		}
		if (d.cage_origin) parts.push(`Jaula: ${d.cage_origin}`);
		if (d.bin_seal_folios) parts.push(`Sellos bins: ${d.bin_seal_folios}`);
		if (d.market_restrictions) {
			parts.push(`Restricciones: ${d.market_restrictions}`);
		}
	}

	return parts;
}
